export const server = "https://sobep-backend-nlqv.vercel.app/api/v1";
export const nif = '4002255349';
export const RC = '0044841-23';
export const phoneNumber = '(+257) 79 92 61 04';

